import * as React from 'react'
import { GoogleLogin, GoogleOAuthProvider, CredentialResponse } from '@react-oauth/google'

interface GoogleSigninButtonProps {
	clientId: string
	googleLogin: (response: CredentialResponse) => void
	text: 'signin_with' | 'signup_with' | 'continue_with' | 'signin'
	size?: 'large' | 'medium' | 'small'
	logo_alignment?: 'left' | 'center'
	width?: string
	theme?: 'outline' | 'filled_blue' | 'filled_black'
}

const GoogleSigninButton: React.FunctionComponent<GoogleSigninButtonProps> = (props) => {
	const clientId = props.clientId
	return clientId ? (
		<GoogleOAuthProvider clientId={clientId}>
			<GoogleLogin
				onSuccess={props.googleLogin}
				size={props.size ? props.size : 'medium'}
				logo_alignment={props.logo_alignment ? props.logo_alignment : 'left'}
				theme={props.theme ? props.theme : 'filled_blue'}
				text={props.text}
				width={props.width ? +props.width : 310} // Has to be a number, otherwise crashes
			/>
		</GoogleOAuthProvider>
	) : (
		<></>
	)
}

export default GoogleSigninButton
